import { ScrollRestoration } from "react-router";
import { CareLayout } from "./CareLayout";
import "./MaintenanceCareLayout.css";
import "../pages/maintenance/Maintenance.css";

export const MaintenanceCareLayout = () => (
  <div className="maintenance-care">
    <ScrollRestoration />
    <div className="maintenance-care-brand">
      <span className="maintenance-brand">MIYUKON</span>
      <span className="maintenance-care-notice">
        Сайт обновляется. Забота о вещах остаётся.
      </span>
    </div>
    <CareLayout />
  </div>
);
